import { useTranslation } from "react-i18next";
import { Text } from "~/components/text";
import { BooksTableDetailRowSectionLabel } from "./books-table-detail-row-section-label";

export const BooksTableDetailRowDescriptionSnippet = ({
  description,
  wordCount,
}: {
  description: string;
  wordCount: number;
}) => {
  const { t } = useTranslation(["components"]);

  if (!description) return null;

  return (
    <div className="flex flex-col gap-1.5">
      <BooksTableDetailRowSectionLabel
        label={t("components:booksTable.detail.description")}
        count={wordCount}
      />
      <Text variant="detail" className="max-w-3xl">
        {description}
      </Text>
    </div>
  );
};
